import {
  Component,
  OnInit,
  AfterViewInit,
  ViewChild,
  ElementRef
} from '@angular/core';

import { B2bComponent } from '../b2b.component';
import { CookieService } from 'ngx-cookie-service';
import { SharedService } from 'src/app/shared.service';
import { ManagementServiceService } from 'src/app/management-service.service';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { B2BService } from 'src/app/b2-b.service';

import jspreadsheet from 'jspreadsheet';
import 'jspreadsheet/dist/jspreadsheet.css';
import 'jsuites/dist/jsuites.css';
import { style } from '@angular/animations';

jspreadsheet.setLicense('YjlmYmJmNjM2YTRkMmQzZmEzOGRkODc3NzhmOWFjOTA2ZWEwYzA1MDczNzUzMjJmZjZmNTkyMmU2ZjkzNTJlYmZiYTRhMzU3Yzg1ZDU2NGM0OTBhNzdjMjE5NjA1N2ZlNzI4NjFjMzUwNzQyOWQ5YzZkOGRhZmRmMTU4NjkyNjQsZXlKamJHbGxiblJKWkNJNklqa3pNRFppT1dKbU5UQm1aVEEzWWpCaVlUWTNaalJtWWpSbVpqazNNV1JsWm1ZM056WTVPRGtpTENKdVlXMWxJam9pYzNSbFptRnVJR05wYjJOaElpd2laR0YwWlNJNk1UYzFOVGt3TXpZd01Dd2laRzl0WVdsdUlqcGJJbmRsWWlJc0lteHZZMkZzYUc5emRDSmRMQ0p3YkdGdUlqb3pNU3dpYzJOdmNHVWlPbHNpZGpjaUxDSjJPQ0lzSW5ZNUlpd2lkakV3SWl3aWRqRXhJaXdpWm05eWJYVnNZU0lzSW1admNtMXpJaXdpY21WdVpHVnlJaXdpY0dGeWMyVnlJaXdpYVcxd2IzSjBaWElpTENKelpXRnlZMmdpTENKamIyMXRaVzUwY3lJc0luWmhiR2xrWVhScGIyNXpJaXdpWTJoaGNuUnpJaXdpY0hKcGJuUWlMQ0ppWVhJaUxDSnphR1ZsZEhNaUxDSnphR0Z3WlhNaUxDSnpaWEoyWlhJaVhYMD0=');

@Component({
  selector: 'app-listprices',
  templateUrl: './listprices.component.html',
  styleUrls: ['./listprices.component.css']
})

export class ListpricesComponent implements OnInit, AfterViewInit  {

  @ViewChild('spreadsheet', { static: false }) spreadsheetRef: ElementRef;
  spreadsheet: any;
  canRenderSpreadsheet = false;

  constructor(public parent: B2bComponent, private managementService:ManagementServiceService, private B2BService:B2BService, private service:SharedService, private cookieService: CookieService, public translate: TranslateService, private router:Router, private _bottomSheet: MatBottomSheet,  private route: ActivatedRoute) { 
    translate.addLangs(['en', 'ro']);
    translate.setDefaultLang('en');

    const browserLang = this.parent.getLanguage();
    translate.use(browserLang.match(/en|ro/) ? browserLang : 'en');
    this.Language = browserLang;

    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
  
     // Debounce search.
     this.searchTermUpdate.pipe(
      debounceTime(250),
      distinctUntilChanged())
      .subscribe(value => {
        if(value?.length > 2){
          this.SearchIndustryProductB2BOffersVersion2(value);
        }
      });
  }

  searchTermUpdate = new Subject<string>();
  CurrentCartItemRow:any;
  Language:any;

  ngOnInit(): void {
    this.canRenderSpreadsheet = true; // triggers rendering

    this.InitializeFilter();
    this.CartItemRows = [];
    const SearchProductsPageMessage = this.cookieService.get('SearchProductsPageMessage');

    if(SearchProductsPageMessage?.length > 0){
      this.ShowSearchProductsPageMessage = false;
    }
    else{
      this.GetB2BHomePageMessage();
    }

    this.PopulateCartItems(50);
  }

  ngAfterViewInit(): void {
    if (this.canRenderSpreadsheet && this.spreadsheetRef && !this.spreadsheet) {
      this.initializeSpreadsheet();
    }
  }

  initializeSpreadsheet() {

    let action = function() {
      let methods = {};

      //@ts-ignore
      methods.createCell = function(cell, value, x, y, instance, options) {
          let input = document.createElement('i');
          input.className = 'material-icons';
          input.style.cursor = 'pointer';
          input.style.fontSize = '22px';
          input.innerHTML = "close";
          input.onclick = function() {
              let id = instance.getRowId(y);
              // Do some action
              alert(id);
          }
  
          cell.appendChild(input);
      }
  
      return methods;
  }();

    this.spreadsheet = jspreadsheet(this.spreadsheetRef.nativeElement, {
      worksheets: [
        {
          columns: [
            { type: 'text', title: '#', width: 50, readOnly: true, height: 25 },
            { type: 'text', title: 'Brand', width: 120, readOnly: true, height: 25 },
            { type: 'text', title: 'Name', width: 120, height: 25 },
            { type: 'text', title: 'Part-Number', width: 180, height: 25 },
            { type: 'numeric', title: 'Cantitate', width: 100, height: 25 },
            { type: 'numeric', title: 'Price', width: 100, readOnly: true, height: 25 },
            { type: 'numeric', title: 'Total', width: 100, readOnly: true, height: 25 },
            { type: 'text', title: 'ETA', width: 100, readOnly: true, height: 25 },
            { type: 'text', title: 'HSCode', width: 100, readOnly: true, height: 25 },
            { type: 'text', title: 'COO', width: 80, readOnly: true, height: 25 },
            { type: 'text', title: 'Greutate', width: 100, readOnly: true, height: 25 },
            { type: action, title: 'Actiuni', width: 80, height: 25 }
          ],
          minDimensions: [11, 50],
          // style:{
          //   "A1":0
          // },
          data:[
            [
              
            ]
          ]
        }
      ],
      toolbar:true,
      onchange: (instance, cell, x, y, value, oldValue) => {
        // Call your custom handler
        this.onCellChanged(x, y, value, oldValue);
      },
      style:[
        "background-color:red;"
      ]
    });

    const worksheet = this.spreadsheet[0];
const rowCount = worksheet.getData().length;
const columnCount = worksheet.options.columns.length;

for (let col = 0; col < columnCount; col++) {
  for (let row = 0; row < rowCount; row++) {
    const cell = worksheet.getCell(row, col);
    worksheet.setStyle(`${cell}`, 'background-color', 'red');
  }
}

    // this.spreadsheet[0].getToolbar();
    console.log(this.spreadsheet[0].getData());
  }

  onCellChanged(x: number, y: number, newValue: string, oldValue: string): void {
    // Column 2 = "Name", Column 3 = "Part-Number"
    if (x.toString() === '2') {
      this.onNameChanged(x, y, newValue, oldValue);
    } else if (x.toString() === '3') {
      this.onPartNumberChanged(x, y, newValue, oldValue);
    }
  }
  
  onNameChanged(x: number, y: number, newValue: string, oldValue: string): void {
    const request = {
      User: this.parent.User,
      Language: this.Language,
      PartnerID: this.parent.B2BPartner?.ID,
      BrandID: null,
      SearchTerm: newValue,
      Pager: {},
      MaxRank: 2,
      CartItems:this.parent.CartItemRows,
      UIID:this.SelectedCartItem.UIID,
    };
  }
  
  onPartNumberChanged(x: number, y: number, newValue: string, oldValue: string): void {
    
  }

  SelectedCartItem:any;

  SelectGridItem(item:any){
    this.SelectedCartItem = JSON.parse(JSON.stringify(item));
  }

  SearchIndustryProductB2BOffersVersion2(searchTerm:string){
    var request = {
      User:this.parent.User,
      Language:this.Language,
      PartnerID:this.parent.B2BPartner?.ID,
      BrandID:null,
      SearchTerm:searchTerm,
      Pager:{

      },
      MaxRank:2,
      CartItems:this.parent.CartItemRows,
      UIID:this.SelectedCartItem.UIID,
    };
  
    this.loadingProducts = true;
  
    this.B2BService.SearchIndustryProductB2BOffersVersion2(request).subscribe(response => {
  
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
     
      }
  
      this.loadingProducts = false;
     });
  }

  Filter: {[k: string]: any} = {};

  InitializeFilter(){

  this.Filter = {};
  this.Filter.SearchTerm = "";

  this.Filter.Pager = {};
  this.Filter.Pager.PageIndex = 1;
  this.Filter.Pager.PageSize = 50;
  this.Filter.Pager.TotalCount = 0;

  this.Filter.Company = {};
  this.Filter.Company = null;

  this.Filter.Brand = {};
  this.Filter.Brand = null;

  this.Filter.ProductBoxStatus = {};
  this.Filter.ProductBoxStatus = null;

  this.Filter.ProductConditionStatus = {};
  this.Filter.ProductConditionStatus = null;

  this.Filter.ProductManufacturingStatus = {};
  this.Filter.ProductManufacturingStatus = null;

  this.Filter.ProductVersionStatus = {};
  this.Filter.ProductVersionStatus = null;

  this.Filter.Creator = {};
  this.Filter.Creator = null;

  this.Filter.Updater = {};
  this.Filter.Updater = null;

  this.Filter.CombineProductsByID = true;
}



ShowSearchProductsPageMessage:boolean;

loadingProducts:boolean;
SearchedProducts:any[];
CartItemRows: {[k: string]: any} = [];

InitializeSearchProduct(item:any){

  this.CurrentCartItemRow = item;
  this.SelectItem(item);

  if((this.SearchedProducts == null || this.SearchedProducts.length == 0) && this.Filter.SearchTerm?.length > 2){
    this.SearchIndustryProducts();
  }
}

OfferPriorityStatuses:any[];
OfferPriorityStatus:any;

PopulateCartItems(rows = 50){
    
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    Rows:rows
  };

  this.loadingProducts = true;

  this.B2BService.PopulateCartItems(request).subscribe(response => {

    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      var CI = JSON.parse(JSON.stringify(response["CartItems"]));
      this.CartItemRows = this.CartItemRows.concat(CI);

      if(this.OfferPriorityStatuses == null || this.OfferPriorityStatuses?.length == 0){
        this.OfferPriorityStatuses = response["OfferPriorityStatuses"];
        this.OfferPriorityStatus = this.OfferPriorityStatuses[0];
      }
    }

    this.loadingProducts = false;
   });
}

GetIndustryProductsStocksFiltered(){
    
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    Filter:this.Filter
  };

  this.loadingProducts = true;

  this.managementService.GetIndustryProductsStocksFiltered(request).subscribe(response => {

    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.SearchedProducts = response["StockProducts"];
    }

    this.loadingProducts = false;
   });
}

AllSelected:boolean;

SelectAll(){
  this.parent.Cart.Items.forEach(r => {
    r.IsSelected = this.AllSelected;
  });

  this.CheckIfAnyChecked();
}

AnyChecked:boolean;

CheckIfAnyChecked(){
  this.AnyChecked = false;

  this.parent.Cart.Items.forEach(element => {
    if(element.IsSelected){
      this.AnyChecked = true;
    }
  });
}

SearchIndustryProducts(){
    
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    Filter:this.Filter
  };

  this.loadingProducts = true;

  this.managementService.SearchIndustryProducts(request).subscribe(response => {

    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.SearchedProducts = response["SearchResults"];
    }

    this.loadingProducts = false;
   });
}

SelectItem(i:any){
  this.CartItemRows.forEach(cell => {
    if(cell.UIID == i.UIID){
      cell.IsSelected = !cell.IsSelected;
    }
    else{
      cell.IsSelected = false;
    }
  });
}

SplitGetIndustryProductsSearchQuery(searchQuery:string){
    
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    SearchQuery:searchQuery,
    UIID:this.CurrentCartItemRow.UIID,
    CartItems:this.CartItemRows,
    Partner:this.parent.B2BPartner
  };

  this.CartItemRows.forEach(cell => {
      if(cell.UIID == this.CurrentCartItemRow.UIID){
        cell.LoadingCell = true;
      }
  });

  this.B2BService.SplitGetIndustryProductsSearchQuery(request).subscribe(response => {

    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.CartItemRows = [];
      this.CartItemRows = JSON.parse(JSON.stringify(response["CartItems"]));

      this.CartItemRows.filter(x => !x.WasSearchedFor && x.UIProductValue?.length > 0).forEach(cell => {
        this.SearchIndustryProductsFromGridCell(cell);
      });
    }

    this.searchTermUpdate.next(null);
   });
}

SearchIndustryProductsFromGridCell(item:any){
    
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    UIID:item.UIID,
    CartItem:item,
  };

  this.CartItemRows.forEach(cell => {
      if(cell.UIID == item.UIID){
        cell.LoadingCell = true;
      }
  });

  this.B2BService.SearchIndustryProductsFromGridCell(request).subscribe(response => {

    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){

      var Item = response["CartItem"];

      this.CartItemRows.forEach((cell, index) => {
        if(cell.UIID == item.UIID){
            this.CartItemRows[index] = JSON.parse(JSON.stringify(Item));
            this.GetGridCellItemData(JSON.parse(JSON.stringify(this.CartItemRows[index])));
        }
      });
    }

    this.CartItemRows.forEach(cell => {
      if(cell.UIID == item.UIID){
        cell.LoadingCell = false;
      }
    });

    this.searchTermUpdate.next(null);
   });
}

SelectGridSearchResult(s:any, item:any){

  item.SearchResults.forEach(element => {
    element.IsSelected = false;
  });

  // Find the index of the matching search result
const index = item.SearchResults.findIndex(searchResult => searchResult.UIID === s.UIID);

// If a matching search result is found
if (index !== -1) {
    // Set isSelected to true
    item.SearchResults[index].IsSelected = true;

    // Move the matching search result to the beginning of the array
    const selectedSearchResult = item.SearchResults.splice(index, 1)[0];
    item.SearchResults.unshift(selectedSearchResult);
}

  this.GetGridCellItemData(JSON.parse(JSON.stringify(item)));
  item.IsSelected = false;
}

GetGridCellItemData(c:any){
    
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    newItem:c,
    Partner:this.parent.B2BPartner
  };

  this.B2BService.GetGridCellItemData(request).subscribe(response => {

    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){

      var Item = response["Item"];

      this.CartItemRows.forEach((cell, index) => {
        if(cell.UIID == c.UIID){
            this.CartItemRows[index] = JSON.parse(JSON.stringify(Item));
        }
    });
    }
   });
}

ExportB2BGrid(){
    
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    CartItems:this.CartItemRows,
  };

  this.parent.loading = true;

  this.B2BService.ExportB2BGrid(request).subscribe(response => {

    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      var Document = response["Document"];
      this.download(Document.Name, Document.PDFStream);
    }
   });

   this.parent.loading = false;
}

download(filename, text) {
  var element = document.createElement('a');
  element.setAttribute('href', 'data:application/pdf;base64,' + encodeURIComponent(text));
  element.setAttribute('download', filename);

  element.style.display = 'none';
  document.body.appendChild(element);

  element.click();

  document.body.removeChild(element);
}

ShowAllProductsDetails:boolean = false;

ShowAllProductsDetailsFunction(e:boolean){
  this.ShowAllProductsDetails = e;
  this.parent.Cart.Items.forEach(element => {
    element.Product.ShowDetails = e;
  });
}

CloseShowSearchProductsPageMessage(){
  this.cookieService.set("SearchProductsPageMessage", "true");
  this.ShowSearchProductsPageMessage = false;
}

B2BHomePageMessage:string;

GetB2BHomePageMessage(){
    
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    Partner:this.parent.B2BPartner,
    Agent:this.parent.B2BAgent
  };

  this.loadingProducts = true;

  this.B2BService.GetB2BHomePageMessage(request).subscribe(response => {

    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.ShowSearchProductsPageMessage = true;
      this.B2BHomePageMessage = response["B2BHomePageMessage"];
      this.GetB2BListedBrands();
    }

    this.loadingProducts = false;
   });
}

Brands:any[];
loadingBrandIcons:boolean = false;

GetB2BListedBrands(){
    
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
  };

  this.loadingBrandIcons = true;

  this.B2BService.GetB2BListedBrands(request).subscribe(response => {

    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.Brands = JSON.parse(JSON.stringify(response["Brands"]));
    }

    this.loadingBrandIcons = false;
   });
}



}
